// Phase 4 build-wall CANARY.
//
// This exact string is the machine-checkable proof of the "no proprietary leak" wall
// (docs/phase4-build-targets/DESIGN.md §4.1). A string literal is NEVER minified, so its
// presence/absence in a built bundle is a reliable probe:
//   - It MUST be PRESENT in dist/internal (positive control — proves the detector can see leakage).
//   - It MUST be ABSENT from dist/adviser and dist/public (the contractual guarantee).
//
// It is imported by src/routes/researchRoutes.tsx — the INTERNAL-ONLY route fragment — and by
// nothing the adviser/public entries compose, so Rollup only ever pulls this module into the
// internal graph. If a future edit makes the adviser/public build reference the research fragment,
// this canary will surface in their bundle and the build-wall Vitest turns red.
export const __RESEARCH_MODULE_MARKER__ = "CBAM_RESEARCH_PROPRIETARY";
